import React from 'react';

const Service = props => (
  <div className={"col-sm-6 col-lg-3 m-15px-tb"}>
    <div className={"p-25px-lr p-35px-tb white-bg box-shadow-lg hover-top border-radius-15"}>
      <div className={"only-icon-70 m-20px-b theme-color d-inline-block"}>
        <i className={props.icon}/>
      </div>
      <h2 className={"m-10px-b"}>{props.title}</h2>
      <p className={"m-0px"}>{props.description}</p>
    </div>
  </div>
);

export default Service;